var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMongodbinline = function SvgMongodbinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.896 25.47C42.516 10.594 35.471 6.634 33.674 3.835A31.832 31.832 0 0 1 31.709 0c-.095 1.321-.27 2.154-1.396 3.156-2.26 2.01-11.863 9.815-12.67 26.715C16.89 45.63 29.255 55.346 30.89 56.35c1.256.617 2.786.014 3.532-.552 5.961-4.081 14.106-14.96 11.481-30.328",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.22 47.958c-.312 3.9-.535 6.167-1.325 8.395 0 0 .518 3.713.883 7.646h1.29a71.32 71.32 0 0 1 1.406-8.234c-1.67-.819-2.19-4.384-2.255-7.807Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.475 55.768c-1.687-.777-2.175-4.418-2.25-7.81.417-5.594.54-11.206.365-16.813-.089-2.943.042-27.251-.727-30.81a29.55 29.55 0 0 0 1.813 3.5c1.797 2.8 8.845 6.76 12.223 21.634 2.631 15.341-5.47 26.192-11.424 30.299Z",
    fill: "currentColor"
  })));
};

export default SvgMongodbinline;